// jquery-slimscroll (and the Bootstrap 4 jQuery plugins) attach themselves to
// the *global* jQuery at evaluation time, so it has to exist before those
// modules are evaluated.
//
// This cannot live in vendor.js: ES module imports are hoisted and every import
// of a module is evaluated before that module's own body runs, so an assignment
// written above `import 'jquery-slimscroll'` would still happen too late.
// Keeping it in its own module means vendor.js can order the side effects by
// listing this import first.
import $ from 'jquery';

window.jQuery = $;
window.$ = $;

export default $;
